export default {
  SERVER_URL: "http://seeai.hqjy.com/",
};
